import { DocumentBlock } from "@entities/journal";
import "./section-third-documents.scss";
import { DocTypeEnum, DocTypeTypes } from "../../../journal-section-form/model/types/document-types";

interface Document {
  id?: string;
  docId?: string;
  docType?: string;
  fileName?: string;
  name?: string;
  documentUrl?: string;
}

interface SectionThirdDocumentsProps {
  docs?: Document[];
}

export const SectionThirdDocuments = ({
  docs = [],
}: SectionThirdDocumentsProps) => {
  const getDocsByType = (type: DocTypeEnum) => {
    return docs.filter((doc) => doc.docType === type);
  };

  const projectDocs = getDocsByType(DocTypeTypes.PROJECT_DOC);
  const workDocs = getDocsByType(DocTypeTypes.WORK_DOC);
  const builtSchemes = getDocsByType(DocTypeTypes.BUILT_SCHEME);
  const builtBlueprints = getDocsByType(DocTypeTypes.BUILT_BLUEPRINT);
  const regulationDocs = getDocsByType(DocTypeTypes.REGULATION_DOC);

  return (
    <div className="section-third-documents">
      <div className="section-third-documents__section">
        <div className="section-third-documents__title">Документы</div>

        <div className="section-third-documents__list">
          {projectDocs.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.docId}
              title="Проектная документация"
              fileName={doc.name || doc.fileName}
              documentUrl={doc.documentUrl}
              docType={DocTypeTypes.PROJECT_DOC}
              docId={doc.docId}
            />
          ))}

          {workDocs.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.docId}
              title="Рабочая документация"
              fileName={doc.name || doc.fileName}
              documentUrl={doc.documentUrl}
              docType={DocTypeTypes.WORK_DOC}
              docId={doc.docId}
            />
          ))}

          {builtBlueprints.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.docId}
              title="Исполнительный чертеж"
              fileName={doc.name || doc.fileName}
              documentUrl={doc.documentUrl}
              docType={DocTypeTypes.BUILT_BLUEPRINT}
              docId={doc.docId}
            />
          ))}

          {builtSchemes.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.docId}
              title="Исполнительная схема"
              fileName={doc.name || doc.fileName}
              documentUrl={doc.documentUrl}
              docType={DocTypeTypes.BUILT_SCHEME}
              docId={doc.docId}
            />
          ))}

          {regulationDocs.map((doc) => (
            <DocumentBlock
              key={doc.id || doc.docId}
              title="Нормативная документация"
              fileName={doc.name || doc.fileName}
              documentUrl={doc.documentUrl}
              docType={DocTypeTypes.REGULATION_DOC}
              docId={doc.docId}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
